// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dd-header[data-v-4557eef7]{font-weight:700;color:#000;font-size:medium;padding:0}", ""]);
// Exports
module.exports = exports;
